fragment AttachmentFragment on AttachmentInterface {
    id
    number
    title
    variations(orderBy: [{ column: "number", order: ASC }]){
        ...AttachmentVariationFragment
    }
    updated_at
    created_at
}